import type { Environment } from '@/scripts/environments'

const NEW_BACKOFFICE_ORIGINS: Record<Environment, string> = {
  production: 'https://backoffice.hivemq.com',
  staging: 'https://backoffice.hmq.dev',
  development: 'https://backoffice.hmq.dev',
  test: 'https://backoffice.hmq.dev',
}

function stripBasePath(href: string, basePath: string) {
  const base = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath
  if (!href.startsWith(base)) {
    return href
  }
  const rest = href.slice(base.length)
  if (rest === '') {
    return '/'
  }
  if (rest.startsWith('/')) {
    return rest
  }
  if (rest.startsWith('?') || rest.startsWith('#')) {
    return `/${rest}`
  }
  return href
}

export function newBackofficeUrl(
  href: string,
  basePath: string,
  environment: Environment,
) {
  return `${NEW_BACKOFFICE_ORIGINS[environment]}${stripBasePath(href, basePath)}`
}
